<template>
    <div class="warranty__page">
        <p>Возврат денежных средств выполняется в течении до 7 дней с момента получения товара нашим магазином, любым удобным для Вас способом:</p>
        <ul>
            <li>перевод на карту банка;</li>
            <li>наличными при возврате товара курьером в городе Киев.</li>
        </ul>
        <p>При покупке товара в интернет магазине LENDO, Вы получаете официальный гарантийный талон. В талоне будут указаны контакты сервисного центра, в который Вы можете обратиться за получением гарантийного обслуживания в течении указанного в талоне гарантийного срока.</p>
        <p>
            <span>Для Киева:</span>
            Если неисправность произошла по вине производителя в течение гарантийного срока, Вам необходимо:
        </p>
        <ul>
            <li>Позвонить по телефону, указанном в гарантийном талоне.</li>
            <li>Дождаться мастера для диагностики или ремонта.</li>
            <li>В течение гарантийного срока - ремонт бесплатный.</li>
        </ul>
        <span>Для регионов:</span>
        <ul>
            <li>Позвонить по телефону, указанном в гарантийном талоне.</li>
            <li>По предоставленным фото или видео сервисный центр подтверждает неисправность.</li>
            <li>При возможности самостоятельного устранения поломки, Вы получите подробную консультацию по ее устранению. В случае неисправности какой-то детали, она будет выслана Вам курьерской службой бесплатно.</li>
            <li>Если устранить проблему на месте нет возможности, необходимо отправить товар в сервисный центр.</li>
            <li>В течение гарантийного срока пересылка и ремонт бесплатны.</li>
        </ul>
        <p>Для этого необходимо связаться с менеджером магазина (на гарантийном талоне и товарном чеке указываются контакты) и обсудить способ возврата товара.</p>
    </div>
</template>

<script>
    export default {
        name: "page1"
    };
</script>

<style scoped lang="scss">
    .warranty__page {
        color: #686F83;
        font-size: 14px;
        line-height: 21px;
        width: 100%;
        span {
            display: block;
            font-size: 16px;
            line-height: 25px;
            margin-bottom: 10px;
        }
        p {
            margin: 10px 0;
        }
        ul {
            list-style-position: inside;
            list-style: none;
            li {
                display: flex;
                margin-bottom: 16px;
                &:before {
                    content: url("/src/assets/img/check.svg");
                    display: block;
                    height: 10px;
                    width: 10px;
                }
            }
        }
    }
</style>
